import React, { useState } from 'react';
import FeedbackModal from './FeedbackModal';

const Footer = ({ onFeedbackClick }) => {
    const [copiedTelebirr, setCopiedTelebirr] = useState(false);
    const [copiedCBE, setCopiedCBE] = useState(false);

    const handleCopy = (text, type) => {
        const updateState = () => {
            if (type === 'telebirr') {
                setCopiedTelebirr(true);
                setTimeout(() => setCopiedTelebirr(false), 2000);
            } else {
                setCopiedCBE(true);
                setTimeout(() => setCopiedCBE(false), 2000);
            }
        };

        const fallbackCopy = (textToCopy) => {
            const textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            // Prevent scrolling to the bottom of the page
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            textArea.style.opacity = "0";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Fallback copy failed', err);
            }
            document.body.removeChild(textArea);
        };

        if (!navigator.clipboard) {
            fallbackCopy(text);
            updateState();
            return;
        }

        navigator.clipboard.writeText(text)
            .then(updateState)
            .catch(() => {
                // If it fails (e.g. secure context required), use fallback
                fallbackCopy(text);
                updateState();
            });
    };

    return (
        <footer className="w-full bg-white/95 backdrop-blur-md border-t border-gray-200 mt-auto shadow-[0_-4px_20px_-5px_rgba(0,0,0,0.1)] rounded-t-[2.5rem] pb-6 pt-2 z-10 relative">
            <div className="px-5 py-8 max-w-3xl mx-auto">
                <div className="text-center mb-8">
                    <h3 className="text-2xl font-black text-gray-800 tracking-tight">Payment Methods</h3>
                    <p className="text-sm text-gray-500 mt-1 font-medium">Tap any card to copy the account number</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    {/* Telebirr Card */}
                    <div
                        onClick={() => handleCopy('995687', 'telebirr')}
                        className="relative overflow-hidden cursor-pointer group bg-gradient-to-br from-cyan-400 to-blue-600 rounded-3xl p-6 text-white shadow-lg shadow-blue-500/30 transform transition-all duration-300 hover:scale-[1.02] active:scale-95 border border-white/20"
                    >
                        {/* Decorative elements */}
                        <div className="absolute top-0 right-0 -mr-8 -mt-8 w-32 h-32 rounded-full bg-white opacity-10 transition-transform group-hover:scale-110"></div>
                        <div className="absolute bottom-0 right-0 mr-4 mb-4 w-12 h-12 rounded-full bg-white opacity-10"></div>

                        <div className="flex justify-between items-center mb-6">
                            <span className="font-extrabold text-xl tracking-wide uppercase drop-shadow-sm">telebirr</span>
                            <div className="bg-white/10 p-1 rounded-full backdrop-blur-sm shadow-sm border border-white/10">
                                <img src="/telebirr-logo.png" alt="Telebirr Logo" className="w-8 h-8 object-contain bg-white rounded-full" />
                            </div>
                        </div>
                        <div>
                            <p className="text-xs text-blue-100 uppercase tracking-widest font-semibold mb-1 opacity-90">Merchant ID</p>
                            <div className="font-mono text-2xl tracking-widest font-bold flex items-center justify-between">
                                995687
                                {copiedTelebirr && (
                                    <span className="text-xs bg-white text-blue-600 px-3 py-1 rounded-full animate-bounce shadow-md font-sans font-bold tracking-normal">
                                        Copied!
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="mt-4 text-sm font-medium text-blue-50 uppercase tracking-wider opacity-90">
                            Addiss Taim PLC
                        </div>
                    </div>

                    {/* CBE Card */}
                    <div
                        onClick={() => handleCopy('1000721236548', 'cbe')}
                        className="relative overflow-hidden cursor-pointer group bg-gradient-to-br from-purple-800 to-indigo-900 rounded-3xl p-6 text-white shadow-lg shadow-purple-900/30 transform transition-all duration-300 hover:scale-[1.02] active:scale-95 border border-white/10"
                    >
                        {/* Decorative elements */}
                        <div className="absolute top-0 right-0 -mr-8 -mt-8 w-32 h-32 rounded-full bg-white opacity-5 transition-transform group-hover:scale-110"></div>
                        <div className="absolute bottom-0 right-0 mr-4 mb-4 w-16 h-16 rounded-full bg-yellow-400 opacity-10"></div>

                        <div className="flex justify-between items-center mb-6">
                            <span className="font-extrabold text-xl tracking-wide uppercase flex items-center drop-shadow-sm">
                                <span className="text-yellow-400 mr-1.5 text-2xl">•</span>CBE
                            </span>
                            <div className="bg-white/10 p-1 rounded-full backdrop-blur-sm shadow-sm border border-white/10">
                                <img src="/cbe-logo.png" alt="CBE Logo" className="w-8 h-8 object-contain" />
                            </div>
                        </div>
                        <div>
                            <p className="text-xs text-purple-200 uppercase tracking-widest font-semibold mb-1 opacity-90">Account Number</p>
                            <div className="font-mono text-xl sm:text-2xl tracking-wider font-bold flex items-center justify-between">
                                1000 721 236 548
                                {copiedCBE && (
                                    <span className="text-xs bg-yellow-400 text-purple-900 px-3 py-1 rounded-full animate-bounce shadow-md font-sans font-bold tracking-normal ml-2">
                                        Copied!
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="mt-4 text-sm font-medium text-purple-200 uppercase tracking-wider opacity-90">
                            Addiss Taim PLC
                        </div>
                    </div>
                </div>

                <div className="mt-10 mb-6 flex justify-center">
                    <button
                        onClick={onFeedbackClick}
                        className="px-6 py-2.5 bg-amber-50 text-amber-600 hover:bg-amber-100 font-bold rounded-full shadow-sm border border-amber-200 transition-all active:scale-95 flex items-center"
                    >
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>
                        Give Feedback
                    </button>
                </div>
                <div className="mt-6 mb-6 flex justify-center">
                    <a
                        href="tel:+251973415556"
                        className="inline-flex items-center px-5 py-2 bg-green-50 text-green-700 hover:bg-green-100 font-bold rounded-full shadow-sm border border-green-200 transition-all active:scale-95"
                    >
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h2.28a2 2 0 011.94 1.515l.516 2.064a2 2 0 01-.45 1.958l-1.27 1.27a16.001 16.001 0 006.586 6.586l1.27-1.27a2 2 0 011.958-.45l2.064.516A2 2 0 0121 18.72V21a2 2 0 01-2 2h-1C9.163 23 1 14.837 1 5V4a2 2 0 012-2z" />
                        </svg>
                       For Order: +251 973 415 556
                    </a>
                </div>

                <div className="text-center text-sm font-medium text-gray-400">
                    &copy; {new Date().getFullYear()} Abyssinia Bistro. All rights reserved.
                </div>
                <div className="text-center text-xs font-medium text-gray-400 mt-2">
                    Created by <a href="https://www.abyssiniamenu.com" className="underline hover:text-blue-600" target="_blank" rel="noopener noreferrer">www.abyssiniamenu.com</a> (Esrael Ermias) 0919353466
                </div>
            </div>
        </footer>
    );
};

export default Footer;
